export default "__VITE_ASSET__B60KI5JF__"